import '../scss/home.scss';
import 'owl.carousel';

$( window ).on( 'load', () => {
  let owlPoles = $( '.js-owl-poles' );

  owlPoles.owlCarousel( {
    autoplay: true,
    loop: true,
    nav: false,
    dots: true,
    margin: 30,
    responsive: {
      0: {
        items: 1
      },
      720: {
        items: 3
      },
      990: {
        items: 5
      }
    }
  } );
});
